import React from 'react';
import { gaugeColorClass, satisfactionColorClass } from '../../utils/format';

export const Gauge = ({ value, max = 100, type = 'fatigue', label, showValue = true }) => {
  const percentage = Math.min(100, Math.max(0, (value / max) * 100));
  const colorClass = type === 'satisfaction' ? satisfactionColorClass(value) : gaugeColorClass(percentage);

  return (
    <div className="w-full" data-testid={`gauge-${type}`}>
      {label && (
        <div className="flex justify-between items-center mb-1">
          <span className="text-xs font-medium text-slate-400">{label}</span>
          {showValue && <span className="text-xs font-semibold text-slate-300">{Math.round(value)}%</span>}
        </div>
      )}
      <div className="h-2 w-full rounded-full bg-ink-700 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${colorClass}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default Gauge;
